import { render, staticRenderFns } from "./InvestorReceivablePaymentsDetail.vue?vue&type=template&id=1ee7f66e&scoped=true&"
import script from "./InvestorReceivablePaymentsDetail.vue?vue&type=script&lang=js&"
export * from "./InvestorReceivablePaymentsDetail.vue?vue&type=script&lang=js&"
import style0 from "./InvestorReceivablePaymentsDetail.vue?vue&type=style&index=0&id=1ee7f66e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee7f66e",
  null
  
)

export default component.exports